<tour step="currentStep" post-tour="postTourCallback()" tour-complete="tourCompleteCallback()">
    <virtual-step
      tourtip="Bu sekmeden ihtiyacınız olabilecek tüm ayarlara ulaşabilirsiniz (raporlama, müşteri yönetimi, çalışan yönetimi, ekip yönetimi, yetkilendirme, iş yönetimi, özel formlar, sms gönderme durumları vs)"
      tourtip-placement="bottom"
      tourtip-step="0"
      tourtip-next-label="Devam Et"
      tourtip-element="#eDropdown"></virtual-step>
    <virtual-step
      tourtip="Buradan yeni görevler oluşturup personellerinize bu görevlerin atamalarını yapabilirsiniz."
      tourtip-placement="bottom"
      tourtip-step="1"
      tourtip-next-label="Devam Et"
      tourtip-element="#eNewTask"></virtual-step>
    <virtual-step
      tourtip="Buradaki sekmeden personellerinizin durumlarını, mobil bilgilerini, ellerindeki işleri ve performanslarını takip edebilirsiniz."
      tourtip-placement="left"
      tourtip-step="2"
      tourtip-next-label="Devam Et"      
      tourtip-element="#eRightPanel"></virtual-step>
    <virtual-step
      tourtip="Buradaki sekmeden oluşturduğunuz görevlerin durumlarını takip edebilir ve bu iş surecinde ki tüm ayrıntılara ulaşabilirsiniz."
      tourtip-placement="right"
      tourtip-step="3"
      tourtip-next-label="Devam Et"      
      tourtip-element="#eLeftPanel"></virtual-step>
    <virtual-step
      tourtip="Buradan atadığınız görevlerin durumlarını oluşturduğunuz ekiplere göre takip edebilir bu iş surecinde ki tüm ayranlara ulaşabilirsiniz."
      tourtip-placement="bottom"
      tourtip-step="4"
      tourtip-next-label="Devam Et"      
      tourtip-element="#eTeamDropDown"></virtual-step>
    <virtual-step
      tourtip="Buradan firma bilgilerinizi, şifre değiştirme ve hesap bilgileriniz ulaşabilir ve değişiklik yapabilirsiniz."
      tourtip-next-label="Tamamla"
      tourtip-placement="bottom"
      tourtip-step="5"
      tourtip-element="#eCompanyDropDown"></virtual-step>
  </tour>
